import React, { ChangeEvent, KeyboardEvent } from "react";
import "./TextArea.scss";

type LabelObject = {
  regularText: string;
  extraText: string;
};

interface TextAreaProps {
  placeholder?: string;
  label?: string | LabelObject;
  defaultValue?: string;
  onChange: (e: ChangeEvent<HTMLTextAreaElement>) => void;
  onKeyDown?: (e: KeyboardEvent<HTMLTextAreaElement>) => void;
  className?: string;
  inputRef?: React.RefObject<HTMLTextAreaElement> | undefined;
  name?: string;
  required?: boolean;
  errorMessage?: string;
}

export function TextArea(props: TextAreaProps): React.ReactElement {
  const isLabelObject = (x: string | LabelObject): x is LabelObject => true;
  const inputId = typeof props?.label === "string" ? props?.label : props?.label?.regularText;

  return (
    <div className={`ta-wrapper ${props.className ?? ""}`}>
      {props?.label &&
        (typeof props?.label === "string" ? (
          <label htmlFor={inputId} className="ta-label">
            {props?.label ? props.label : ""}
          </label>
        ) : isLabelObject(props?.label) ? (
          <span className="ta-label-container">
            <label htmlFor={inputId} className="ta-label">
              {props.label?.regularText}

              <span className="ta-label-optional">{props?.label?.extraText}</span>
            </label>
          </span>
        ) : (
          <></>
        ))}
      <textarea
        className={`ta-input ${props.className ?? ""}`}
        placeholder={props.placeholder ?? "Enter text"}
        defaultValue={props.defaultValue}
        onChange={props.onChange}
        onKeyDown={props.onKeyDown}
        ref={props.inputRef ?? undefined}
        name={props.name}
        required={props.required}
        style={props.errorMessage ? { border: "1px solid #e54646" } : {}}
      />
      {props?.errorMessage && (
        <span className="ta-error-container">
          <label htmlFor={inputId} className="ta-error">
            {props?.errorMessage ?? ""}
          </label>
        </span>
      )}
    </div>
  );
}
